/* eslint-disable no-restricted-globals */
import React from 'react';
import PropTypes from 'prop-types';

import axios from 'axios';

import { GoogleOneTap } from '@spotahome/ui-library';

import {
  getPagePath,
  useSoyuzLocales,
  useSoyuzFlag,
  useSoyuzClientConfig
} from '@spotahome/soyuz/client';
import Metrics from '@spotahome/soyuz-metrics';

const GoogleOneTapWrapper = ({ isUserLogged }) => {
  const OAUTH_LOGIN_URI = getPagePath('externals.one-tap-login');
  const { current: currentLocale } = useSoyuzLocales();
  const { googleOneTapId } = useSoyuzClientConfig();

  const handleGoogleOneTapSuccess = response => {
    const { credential } = response;
    axios
      .post(OAUTH_LOGIN_URI, {
        credential,
        locale: currentLocale
      })
      .then(() => {
        window.location.reload();
        Metrics.ga.sendEvent('signup/login', 'modal-signup', 'google');
      });
  };

  return (
    useSoyuzFlag('GoogleOneTapEnabled').isOn() &&
    !isUserLogged && (
      <GoogleOneTap
        googleOneTapId={googleOneTapId}
        handleSuccessCallback={handleGoogleOneTapSuccess}
      />
    )
  );
};

GoogleOneTapWrapper.propTypes = {
  isUserLogged: PropTypes.bool.isRequired
};

export default GoogleOneTapWrapper;
